import { createTheme } from "@mui/material/styles";
import { palette } from "./palette";
import { components } from "./components";

/**
 * Tema personalizado Material-UI v7+ para VillApps
 *
 * REGLAS ESTRICTAS APLICADAS - COMPACT THEME + DESKTOP FIRST:
 * - COMPACT THEME: Todos los componentes con size="small" por defecto
 * - UI VERTICALMENTE DENSA: Padding reducido, spacing compacto
 * - SIEMPRE dense={true} en listas y tablas (por defecto)
 * - PROHIBIDO <Grid> y <Grid2> - SOLO <Stack>
 * - Diseño desktop-first con adaptación móvil
 * - Colores basados en logo VillApps
 * - MenuDrawer estilo profesional en desktop
 *
 * Paleta de colores:
 * - Azul principal: #6B9BD2 (del logo)
 * - Naranja acento: #E67E22 (del logo)
 * - Escala de grises para texto y fondos
 */
export const theme = createTheme({
  palette,
  components,

  typography: {
    fontFamily: [
      '"Inter"',
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
    ].join(","),

    h1: {
      fontSize: "2.5rem", // Aumentado para desktop
      fontWeight: 600,
      lineHeight: 1.2,
    },

    h2: {
      fontSize: "2rem", // Aumentado para desktop
      fontWeight: 600,
      lineHeight: 1.3,
    },

    h3: {
      fontSize: "1.75rem", // Aumentado para desktop
      fontWeight: 600,
      lineHeight: 1.3,
    },

    h4: {
      fontSize: "1.5rem", // Aumentado para desktop
      fontWeight: 600,
      lineHeight: 1.4,
    },

    h5: {
      fontSize: "1.25rem", // Aumentado para desktop
      fontWeight: 600,
      lineHeight: 1.4,
    },

    h6: {
      fontSize: "1.125rem", // Aumentado para desktop
      fontWeight: 600,
      lineHeight: 1.4,
    },

    body1: {
      fontSize: "1rem", // Aumentado de 0.875rem para desktop
      lineHeight: 1.5,
    },

    body2: {
      fontSize: "0.875rem", // Aumentado de 0.75rem para desktop
      lineHeight: 1.5,
    },

    button: {
      fontSize: "0.9rem", // Ligeramente aumentado para desktop
      fontWeight: 500,
      textTransform: "none",
    },
  },

  spacing: 8,

  shape: {
    borderRadius: 8,
  },

  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960, // Desktop-first: tablet/desktop breakpoint
      lg: 1280, // Large desktop
      xl: 1920, // Extra large desktop
    },
  },
});
